import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=06e6fcab&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=06e6fcab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6fcab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e6fcab')) {
      api.createRecord('06e6fcab', component.options)
    } else {
      api.reload('06e6fcab', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=06e6fcab&scoped=true&", function () {
      api.rerender('06e6fcab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Se0fUePUQDoA/JS/comp/SearchFilterTokens.vue"
export default component.exports